export var VendorProviderEnum;
(function (VendorProviderEnum) {
    VendorProviderEnum["GOPARROT"] = "goparrot";
    VendorProviderEnum["TOAST"] = "toast";
    VendorProviderEnum["SQUARE"] = "square";
    VendorProviderEnum["CHOWLY"] = "chowly";
    VendorProviderEnum["OTTER"] = "otter";
    VendorProviderEnum["CLOVER"] = "clover";
})(VendorProviderEnum || (VendorProviderEnum = {}));
//# sourceMappingURL=VendorProviderEnum.js.map